import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { shallowEqual } from 'app-source/utils/shallowEqual';
import { UserWithPoints } from './UserWithPoints';

const styles = (theme) => ({
  bold: {
    fontWeight: 800,
  },
  content: {
    paddingTop: 0,
    paddingBottom: 0,
  },

  leaderBoard: {
    counterReset: 'leaderBoard-counter',
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    listStyle: 'none',
    margin: [[0, -theme.spacing.unit, -theme.spacing.unit, -theme.spacing.unit]],
    padding: 0,
    '& > li': {
      counterIncrement: 'leaderBoard-counter',
      flex: '1 0 auto',
      paddingLeft: theme.spacing.unit * 4,
      position: 'relative',
      margin: theme.spacing.unit,
      maxWidth: '33%',
    },
    '& > li:before': {
      color: '#000',
      content: 'counter(leaderBoard-counter)',
      fontSize: '1.2rem',
      fontWeight: 'bold',
      left: 0,
      padding: theme.spacing.unit,
      position: 'absolute',
      top: 0,
    },
  },

  overline: {
    fontWeight: 'bold',
    letterSpacing: 1,
    lineHeight: 1.3,
    margin: [[theme.spacing.unit, 0]],
    opacity: 0.5,
  },
});

class TriviaLeaderboardContentComponent extends Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    leaderboardData: PropTypes.arrayOf(
      PropTypes.shape({
        userId: PropTypes.string.isRequired,
        chatName: PropTypes.string.isRequired,
        points: PropTypes.number.isRequired,
      }),
    ),
  };

  static defaultProps = {
    leaderboardData: [],
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this, nextProps, nextState, {
      propsSelectOptions: { omit: ['classes'] },
    });
  }

  render() {
    const { classes, leaderboardData } = this.props;

    return (
      <CardContent className={classes.content}>
        <Typography variant="overline" className={classes.overline}>
          Contest Winners
        </Typography>
        <ol className={classes.leaderBoard}>
          {leaderboardData.map(({ userId, ...user }, pos) => (
            <UserWithPoints key={userId} isWinner={pos === 0} {...user} />
          ))}
        </ol>
      </CardContent>
    );
  }
}

export const TriviaLeaderboardContent = withStyles(styles)(TriviaLeaderboardContentComponent);
